"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DropdownContainer = exports.Dropdown = exports.DropdownMenu = exports.Option = exports.ErrorMessage = exports.OptionContainer = exports.MenuContainer = exports.DropdownInput = exports.Container = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(["\n  font-family: ", ";\n  ", ";\n  font-weight: ", ";\n  box-sizing: border-box;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: ", ";\n  background-color: ", ";\n  border-radius: 4px;\n  height: ", ";\n  margin: ", ";\n  width: ", ";\n  padding: ", ";\n  cursor: pointer;\n  user-select: none;\n  border: ", ";\n\n  :focus {\n    box-shadow: ", ";\n    outline: 5px auto #0042CB;\n    border: none;\n    background-color: ", ";\n  }\n  ", "\n"], ["\n  font-family: ", ";\n  ", ";\n  font-weight: ", ";\n  box-sizing: border-box;\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  color: ", ";\n  background-color: ", ";\n  border-radius: 4px;\n  height: ", ";\n  margin: ", ";\n  width: ", ";\n  padding: ", ";\n  cursor: pointer;\n  user-select: none;\n  border: ", ";\n\n  :focus {\n    box-shadow: ", ";\n    outline: 5px auto #0042CB;\n    border: none;\n    background-color: ", ";\n  }\n  ", "\n"]),
    _templateObject2 = _taggedTemplateLiteral(["\n      :hover {\n        background-color: ", ";\n        font-weight: ", ";\n      }\n    "], ["\n      :hover {\n        background-color: ", ";\n        font-weight: ", ";\n      }\n    "]),
    _templateObject3 = _taggedTemplateLiteral(["\n  font-family: ", ";\n  ", ";\n  font-weight: ", ";\n  appearance: none;\n  border: none;\n  width: 100%;\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  background: transparent;\n  pointer-events: none;\n  cursor: pointer;\n\n  ::placeholder {\n    color: ", ";\n    font-weight: ", ";\n    opacity: 1;\n    text-align: ", "\n  }\n"], ["\n  font-family: ", ";\n  ", ";\n  font-weight: ", ";\n  appearance: none;\n  border: none;\n  width: 100%;\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  background: transparent;\n  pointer-events: none;\n  cursor: pointer;\n\n  ::placeholder {\n    color: ", ";\n    font-weight: ", ";\n    opacity: 1;\n    text-align: ", "\n  }\n"]),
    _templateObject4 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  position: absolute;\n  top: ", ";\n  bottom: ", ";\n  left: ", ";\n  z-index: 10;\n  border-radius: 4px;\n  background-color: ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n  width: ", ";\n  max-height: ", ";\n  overflow-y: scroll;\n  cursor: pointer;\n"], ["\n  box-sizing: border-box;\n  position: absolute;\n  top: ", ";\n  bottom: ", ";\n  left: ", ";\n  z-index: 10;\n  border-radius: 4px;\n  background-color: ", ";\n  background-color: ", ";\n  box-shadow: ", ";\n  width: ", ";\n  max-height: ", ";\n  overflow-y: scroll;\n  cursor: pointer;\n"]),
    _templateObject5 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  background-color: ", ";\n  background-color: ", ";\n  padding: 11px 15px;\n  height: 48px;\n  cursor: pointer;\n  :hover {\n    background-color: ", ";\n    font-weight: ", ";\n  }\n  :focus {\n    outline: 0;\n  }\n  font-family: ", "\n"], ["\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  background-color: ", ";\n  background-color: ", ";\n  padding: 11px 15px;\n  height: 48px;\n  cursor: pointer;\n  :hover {\n    background-color: ", ";\n    font-weight: ", ";\n  }\n  :focus {\n    outline: 0;\n  }\n  font-family: ", "\n"]),
    _templateObject6 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 12px;\n  line-height: 1;\n  position: absolute;\n  bottom: 0;\n  ", ";\n"], ["\n  color: ", ";\n  font-size: 12px;\n  line-height: 1;\n  position: absolute;\n  bottom: 0;\n  ", ";\n"]),
    _templateObject7 = _taggedTemplateLiteral(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n"], ["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px;\n"]),
    _templateObject8 = _taggedTemplateLiteral(["\n  ", ";\n"], ["\n  ", ";\n"]);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactOnclickoutside = require("react-onclickoutside");

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _buoyArrow = require("buoy-arrow");

var _buoyArrow2 = _interopRequireDefault(_buoyArrow);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _buoyText = require("buoy-text");

var _buoyTheme = require("buoy-theme");

var _buoyIcons = require("buoy-icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var focusBoxShadow = 'rgba(0, 0, 0, 0.24) 0 0 12px 0';

var Container = exports.Container = _styledComponents2.default.div.withConfig({
  displayName: "src__Container",
  componentId: "jwqzeu-0"
})(_templateObject, _buoyTheme.fontFamily, (0, _buoyTheme.fontSize)("bodyMain"), _buoyTheme.fontWeight.light, _buoyTheme.colors.neutralDarkest, function (props) {
  return props.languageSelector ? _buoyTheme.colors.white : _buoyTheme.colors.neutralLightest;
}, function (props) {
  return props.languageSelector ? "auto" : "48px";
}, function (props) {
  return props.languageSelector ? "auto 10px auto auto" : "";
}, function (props) {
  return props.width ? props.width : "100%";
}, function (props) {
  return props.languageSelector ? "11px 12px" : "11px 15px";
}, function (props) {
  return props.error && !props.languageSelector ? "1px solid " + _buoyTheme.colors.error(props) : !props.languageSelector ? "1px solid " + _buoyTheme.colors.neutralLightest(props) : "none";
}, focusBoxShadow, _buoyTheme.colors.neutralLightest, function (props) {
  return props.languageSelector && (0, _styledComponents.css)(_templateObject2, _buoyTheme.colors.neutralLightest, _buoyTheme.fontWeight.bold);
});

var DropdownInput = exports.DropdownInput = _styledComponents2.default.input.attrs({ readOnly: true }).withConfig({
  displayName: "src__DropdownInput",
  componentId: "jwqzeu-1"
})(_templateObject3, _buoyTheme.fontFamily, (0, _buoyTheme.fontSize)("bodyMain"), _buoyTheme.fontWeight.light, function (props) {
  return props.languageSelector ? _buoyTheme.colors.black : _buoyTheme.colors.neutral;
}, _buoyTheme.fontWeight.regular, function (props) {
  return props.languageSelector ? "center" : "";
});

var MenuContainer = exports.MenuContainer = _styledComponents2.default.div.withConfig({
  displayName: "src__MenuContainer",
  componentId: "jwqzeu-2"
})(_templateObject4, function (props) {
  return props.dropUp ? "auto" : props.languageSelector ? "40px" : 0;
}, function (props) {
  return props.dropUp ? 0 : props.languageSelector ? "" : "auto";
}, function (props) {
  return props.languageSelector ? "-40px" : 0;
}, _buoyTheme.colors.neutralDarkest, _buoyTheme.colors.neutralLightest, _buoyTheme.constants.boxShadow, function (props) {
  return props.languageSelector ? "140px" : "100%";
}, function (props) {
  return props.languageSelector ? "290px" : "210px";
});

var OptionContainer = exports.OptionContainer = _styledComponents2.default.div.withConfig({
  displayName: "src__OptionContainer",
  componentId: "jwqzeu-3"
})(_templateObject5, function (props) {
  return props.languageSelector ? "center" : "";
}, _buoyTheme.colors.neutralDarkest, function (props) {
  return props.selected ? _buoyTheme.colors.neutralLightest(props) : _buoyTheme.colors.white(props);
}, _buoyTheme.colors.neutralLightest, _buoyTheme.fontWeight.bold, function (props) {
  return props.optionValue === "zh" ? "Arial Unicode MS" : "" + _buoyTheme.fontFamily;
});

var ErrorMessage = exports.ErrorMessage = (0, _styledComponents2.default)(_buoyText.Paragraph).withConfig({
  displayName: "src__ErrorMessage",
  componentId: "jwqzeu-4"
})(_templateObject6, _buoyTheme.colors.error, function (props) {
  return props.margin ? props.margin : "margin: 4px 0 8px";
});

var ScreenReaderOnly = (0, _styledComponents.css)(_templateObject7);

var ScreenReaderOnlyText = _styledComponents2.default.span.withConfig({
  displayName: "src__ScreenReaderOnlyText",
  componentId: "jwqzeu-5"
})(_templateObject8, ScreenReaderOnly);

var Option = exports.Option = function Option(_ref) {
  var option = _ref.option,
      value = _ref.value,
      onChange = _ref.onChange,
      error = _ref.error,
      languageSelector = _ref.languageSelector,
      reset = _ref.reset,
      id = _ref.id;
  return _react2.default.createElement(
    OptionContainer,
    {
      id: id,
      tabIndex: "-1",
      autoFocus: option.value === value,
      onClick: function onClick() {
        // for language selection, reset afterwards
        if (languageSelector) {
          onChange(option);
          reset();
        } else {
          onChange(option);
        }
      },
      selected: option.value === value,
      error: error,
      languageSelector: languageSelector,
      role: "option",
      "aria-selected": option.value === value,
      optionValue: option.value,
      "aria-live": option.value === value ? "polite" : "off"
    },
    option.text
  );
};

var DropdownMenu = exports.DropdownMenu = function DropdownMenu(_ref2) {
  var options = _ref2.options,
      value = _ref2.value,
      onChange = _ref2.onChange,
      menuRef = _ref2.menuRef,
      dropUp = _ref2.dropUp,
      languageSelector = _ref2.languageSelector,
      reset = _ref2.reset;
  return _react2.default.createElement(
    MenuContainer,
    { innerRef: menuRef, dropUp: dropUp, languageSelector: languageSelector },
    options.map(function (option) {
      return _react2.default.createElement(Option, {
        key: option.value,
        option: option,
        onChange: onChange,
        value: value,
        languageSelector: languageSelector,
        reset: reset,
        id: option.value
      });
    })
  );
};

var getOptText = function getOptText(options, value) {
  if (options) {
    var option = options.find(function (o) {
      return value === o.value;
    });
    return option && option.text;
  }
  return false;
};

var getScreenReaderText = function getScreenReaderText(left, right, focused, focusLeft, focusedRight) {
  var singleDropdownText = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;

  // note: "focused" variable means opened -- consider renaming 
  if (focused) return;
  if (left && !focused && focusLeft) {
    return _react2.default.createElement(
      ScreenReaderOnlyText,
      { "aria-live": "polite" },
      "You selected: ",
      left.text
    );
  } else if (left && right && !focused && focusedRight) {
    return _react2.default.createElement(
      ScreenReaderOnlyText,
      { "aria-live": "polite" },
      "You selected: ",
      right.text,
      " Your selection is: ",
      left.text,
      right.text
    );
  } else if (singleDropdownText && !focused) {
    return _react2.default.createElement(
      ScreenReaderOnlyText,
      { "aria-live": "polite" },
      "You selected: ",
      singleDropdownText
    );
  }
};

var Dropdown = exports.Dropdown = function Dropdown(_ref3) {
  var ariaLabel = _ref3.ariaLabel,
      displayError = _ref3.displayError,
      dropdownRef = _ref3.dropdownRef,
      dropUp = _ref3.dropUp,
      focused = _ref3.focused,
      focusedLeft = _ref3.focusedLeft,
      focusedRight = _ref3.focusedRight,
      forceShowError = _ref3.forceShowError,
      languageSelector = _ref3.languageSelector,
      languageOnChange = _ref3.languageOnChange,
      menuRef = _ref3.menuRef,
      options = _ref3.options,
      noMargin = _ref3.noMargin,
      onBlur = _ref3.onBlur,
      onChange = _ref3.onChange,
      onClick = _ref3.onClick,
      onFocus = _ref3.onFocus,
      onKeyDown = _ref3.onKeyDown,
      placeholder = _ref3.placeholder,
      reset = _ref3.reset,
      selectedLeft = _ref3.selectedLeft,
      selectedRight = _ref3.selectedRight,
      singleDropdown = _ref3.singleDropdown,
      tabIndex = _ref3.tabIndex,
      value = _ref3.value,
      width = _ref3.width;
  return _react2.default.createElement(
    Container,
    {
      innerRef: dropdownRef,
      onKeyDown: onKeyDown,
      noMargin: noMargin,
      tabIndex: tabIndex,
      error: displayError || forceShowError,
      onFocus: onFocus,
      onBlur: onBlur,
      width: width,
      languageSelector: languageSelector,
      role: "listbox",
      "aria-label": ariaLabel ? ariaLabel : "",
      "aria-expanded": focused ? "true" : "false",
      onClick: onClick,
      "aria-activedescendant": value
    },
    !singleDropdown && getScreenReaderText(selectedLeft, selectedRight, focused, focusedLeft, focusedRight),
    singleDropdown && getScreenReaderText(null, null, focused, null, null, getOptText(options, value)),
    languageSelector && _react2.default.createElement(_buoyIcons.GlobeIcon, null),
    _react2.default.createElement(DropdownInput, {
      value: !languageSelector ? getOptText(options, value) : "",
      placeholder: placeholder,
      languageSelector: languageSelector,
      tabIndex: "-1"
    }),
    !languageSelector && _react2.default.createElement(_buoyArrow2.default, null),
    focused && _react2.default.createElement(DropdownMenu, {
      menuRef: menuRef,
      dropUp: dropUp,
      value: value,
      options: options,
      onChange: languageSelector ? languageOnChange : onChange,
      languageSelector: languageSelector,
      reset: reset
    })
  );
};

var DropdownContainer = exports.DropdownContainer = function (_React$Component) {
  _inherits(DropdownContainer, _React$Component);

  function DropdownContainer(props) {
    _classCallCheck(this, DropdownContainer);

    var _this = _possibleConstructorReturn(this, (DropdownContainer.__proto__ || Object.getPrototypeOf(DropdownContainer)).call(this, props));

    _this.onKeyDown = function (e) {
      e.preventDefault();
      var _this$state = _this.state,
          focused = _this$state.focused,
          options = _this$state.options,
          value = _this$state.value;
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          languageOnChange = _this$props.languageOnChange;

      var key = e.key;
      var keyOpts = ["Tab", "Enter", "Up", "ArrowUp", "Down", "ArrowDown", "Escape"];
      // Open dropdowns on ENTER or ARROW DOWN or SPACE
      if (key === "Enter" && !focused) {
        _this.setState({
          focused: true
        });
        return;
      } else if (key === "ArrowDown" || e.keyCode === 32) _this.setState({ focused: true });
      // Allow user to select option with SPACE/ENTER
      var selectedOption = options.find(function (o) {
        return value === o.value;
      });
      if ((e.keyCode === 32 || key === "Enter") && selectedOption) {
        if (languageOnChange) {
          languageOnChange(selectedOption);
          _this.reset();
        } else onChange(selectedOption);
      }
      if (!keyOpts.includes(key)) return;
      // tab/enter off, hide dropdown
      if (key === "Tab" || key === "Escape") {
        _this.setState(_extends({}, _this.state, {
          focused: false,
          edited: true
        }));
        // Maintain focus except for on tab
        if (key === "Tab") {
          e.target.blur();
          // NOTE: hacky solution to focus/tabbing being trapped in dropdowns/nav in Safari
          _this.setState({ tabIndex: "-1" });
          setTimeout(function () {
            _this.setState({ tabIndex: "0" });
          }, 1000);
        }
        return;
      }

      e.preventDefault();

      var index = options.findIndex(function (o) {
        return o.value === value;
      });
      var option = options[index];

      // if key down and none selected, select option 1
      if ((key === "Down" || key === "ArrowDown") && !option) {
        option = options[0];
        _this.menu.scrollTop = _this.menu.children[0].offsetTop;

        // if key down and not last option, select next option
      } else if (option && (key === "Down" || key === "ArrowDown") && option !== options[options.length - 1]) {
        option = options[index + 1];
        _this.menu.scrollTop = _this.menu.children[index + 1].offsetTop;

        // if key up and not first option, select prev option
      } else if (option && (key === "Up" || key === "ArrowUp") && option !== options[0]) {
        option = options[index - 1];
        _this.menu.scrollTop = _this.menu.children[index - 1].offsetTop;
      }
      _this.updateValue(option, focused);
    };

    _this.onChange = function (option) {
      _this.updateValue(option, false);
    };

    _this.updateValue = function (option, focused) {
      if (option.value) {
        _this.setState(_extends({}, _this.state, {
          value: option.value,
          focused: focused
        }));
      }
      if (_this.props.onChange) _this.props.onChange(option.value);
    };

    _this.handleClickOutside = function () {
      _this.setState({
        focused: false
      });
    };

    _this.onFocus = function () {
      if (typeof window !== "undefined") {
        var dropUp = _this.dropdown ? window.innerHeight - (_this.dropdown.getBoundingClientRect().bottom + (210 - _this.dropdown.getBoundingClientRect().height)) <= 0 : false;
        // NOTE: do not auto-open dropdown on focus
        _this.setState({
          edited: true,
          dropUp: dropUp
        });
      }
    };

    _this.onBlur = function () {
      if (_this.props.setFocus && _this.props.shouldFocus) _this.props.setFocus();
    };

    _this.onClick = function () {
      _this.setState({ focused: !_this.state.focused });
    };

    _this.reset = function () {
      _this.setState({
        value: "",
        focused: false
      });
    };

    _this.state = {
      focused: false,
      edited: false,
      dropUp: false,
      value: props.value || "",
      tabIndex: "0"
    };
    return _this;
  }

  _createClass(DropdownContainer, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _state = this.state,
          value = _state.value,
          options = _state.options,
          focused = _state.focused;
      var _props = this.props,
          languageModalClosed = _props.languageModalClosed,
          shouldFocus = _props.shouldFocus;
      // set focus back to dropdown on modal close

      if (shouldFocus && languageModalClosed && this.dropdown) this.dropdown.focus();
      if (!prevState.focused && focused) {
        // We just focused the dropdown, scroll to the selected option.
        var index = options.findIndex(function (o) {
          return o.value === value;
        });

        if (index >= 0 && this.menu) {
          this.menu.scrollTop = this.menu.children[index].offsetTop;
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _state2 = this.state,
          edited = _state2.edited,
          focused = _state2.focused;
      var _props2 = this.props,
          showError = _props2.showError,
          error = _props2.error,
          forceShowError = _props2.forceShowError;

      var displayError = edited && showError === true && !focused || forceShowError;
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(Dropdown, _extends({
          dropdownRef: this.props.dropdownRef || function (d) {
            return _this2.dropdown = d;
          },
          menuRef: this.props.menuRef || function (m) {
            return _this2.menu = m;
          },
          dropUp: this.state.dropUp,
          onClick: this.onClick,
          onKeyDown: this.onKeyDown,
          onChange: this.onChange,
          onFocus: this.onFocus,
          onBlur: this.onBlur,
          focused: this.state.focused,
          value: this.state.value,
          options: this.state.options,
          placeholder: this.state.placeholder,
          tabIndex: this.state.tabIndex,
          displayError: displayError,
          width: this.props.width,
          reset: this.reset,
          singleDropdown: true
        }, this.props)),
        displayError && error && _react2.default.createElement(
          ErrorMessage,
          { margin: this.props.errorMargin },
          error
        )
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      return _extends({}, state, {
        options: props.options || [],
        placeholder: props.placeholder || "Select one",
        value: props.value || state.value || ""
      });
    }
  }]);

  return DropdownContainer;
}(_react2.default.Component);

DropdownContainer.propTypes = {
  error: _propTypes2.default.string,
  errorMargin: _propTypes2.default.string,
  forceShowError: _propTypes2.default.bool,
  options: _propTypes2.default.array.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string.isRequired,
  showError: _propTypes2.default.bool,
  value: _propTypes2.default.any
};

exports.default = (0, _reactOnclickoutside2.default)(DropdownContainer);


//////////////////
// WEBPACK FOOTER
// ./~/buoy-dropdown/dist/index.js
// module id = 147
// module chunks = 168707334958949